module.exports = new __parcel__URL__("Klug.ca5e2ff0.avif").toString();